import styled from '@emotion/styled'
	
export const List = styled.ul`
	margin: 20px 0 0 0;
	padding: 0;
	list-style: none;
`;


